import script from "./InputWithVariablesPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputWithVariablesPreview.vue?vue&type=script&lang=ts&setup=true"

import "./InputWithVariablesPreview.vue?vue&type=style&index=0&id=8f49fdbc&lang=scss"

const __exports__ = script;

export default __exports__